import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Lock } from "lucide-react";

export default function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/achievements").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="achievements-page">
      <div>
        <div className="label-tech">Trophy Hall</div>
        <h1 className="h-display text-3xl sm:text-4xl mt-1">
          <span className="text-fuchsia-400">Awakened</span> Titles
        </h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {items.map((a) => (
          <div
            key={a.key}
            data-testid={`achievement-${a.key}`}
            className={`panel p-5 flex flex-col items-center text-center ${
              a.unlocked
                ? "border-fuchsia-400/60 shadow-[0_0_25px_-8px_rgba(217,70,239,0.4)]"
                : "opacity-60"
            }`}
          >
            <div
              className={`w-14 h-14 flex items-center justify-center border ${
                a.unlocked
                  ? "border-fuchsia-400 text-fuchsia-300 bg-fuchsia-500/10"
                  : "border-white/15 text-slate-500"
              }`}
            >
              {a.unlocked ? <Trophy size={24} /> : <Lock size={20} />}
            </div>
            <div className="mt-3 font-display uppercase tracking-wider font-semibold">{a.name}</div>
            <div className="text-xs text-slate-400 mt-1">{a.desc}</div>
            <div className={`text-[0.6rem] font-mono-tech mt-2 uppercase tracking-widest ${a.unlocked ? "text-emerald-400" : "text-slate-600"}`}>
              {a.unlocked ? "Unlocked" : "Locked"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
